/* eslint react/display-name:0 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { TNotificationPayload, TNotificationSubtlePayload } from '@pes-ui/utils/lib/types/notifications';
import { ENotificationType, EStatus, INIT_NOTIFICATION, ENotificationPageType } from '@pes-ui/utils/lib/constants';

export const NotificationStorageContext = React.createContext({});

interface NotificationType extends TNotificationPayload {
    id: number
}

interface Props {}

interface State {
    stack: NotificationType[];
}

export class NotificationStorageProvider extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            stack: [],
        };
    }

    componentDidUpdate() {
        if (this.state.stack?.length > 0) {
            const notification = this.state.stack[0];
            this.dispatchErrorNotification(notification);
            this.removeNotification(notification.id);
        }
    }

    dispatchErrorNotification(notification: NotificationType) {
        const { type, status, message, productsList, buttonText, countryCode, languageCode } = notification;
        const initNotificationEvent =
          new CustomEvent<TNotificationSubtlePayload>(INIT_NOTIFICATION, {
            detail: {
              type,
              status,
              content: message,
              productsList,
              buttonText,
              countryCode,
              languageCode,
              pageType: ENotificationPageType.PRODUCT_CART,
            },
            bubbles: true,
          });
        const node = ReactDOM.findDOMNode(this);
        node.dispatchEvent(initNotificationEvent);
    }

    addNotification = (payload: TNotificationPayload): void => {
        const {
            type = ENotificationType.WITH_HTML,
            status = EStatus.ERROR, message = '',
            productsList,
            buttonText,
            countryCode,
            languageCode,
        } = payload;

        const newNotificationId = this.state.stack.length
            ? this.state.stack[this.state.stack.length - 1].id + 1
            : 1;

        this.setState({
            stack: [
                ...this.state.stack,
                {
                    id: newNotificationId,
                    type,
                    status,
                    message,
                    productsList,
                    buttonText,
                    countryCode,
                    languageCode,
                },
            ],
        });
    };

    removeNotification = (removeId: number): void => {
        this.setState({
            stack: this.state.stack.filter(err => err.id !== removeId),
        });
    };

    render() {
        return (
            <NotificationStorageContext.Provider
                value={{
                    notification: {
                        stack: this.state.stack,
                        addNotification: this.addNotification,
                        removeNotification: this.removeNotification,
                    },
                }}
            >
                {this.props.children}
            </NotificationStorageContext.Provider>
        );
    }
}

export const withNotificationStorageContext = BaseComponent => props => (
    <NotificationStorageContext.Consumer>
        {notification => <BaseComponent {...notification} {...props} />}
    </NotificationStorageContext.Consumer>
);
